export function normPixelToCanvas(x, y, canvasWidth) {
    return {
        x: x * canvasWidth,
        y: y * canvasWidth
    }
}


export function canvasPixelToNorm(x, y, canvasWidth) {
    return {
        x: x / canvasWidth,
        y: y / canvasWidth
    }
}

export function normValueToPixel(value, canvasWidth) {
    return value * canvasWidth;
}

export function pixelValueToNorm(pixel, canvasWidth) {
    return pixel / canvasWidth;
}
